<template>
    <div class="wrap">
        <div class="upType">
            <div :class="isOriginal?'tab active':'tab'" @click="tabOriginal(1)">
                存证认证
            </div>
            <div class="fgx"></div>
            <div :class="isOriginal?'tab':'tab active'" @click="tabOriginal(2)">
                保密认证
            </div>
        </div>
        <div class="applyName">
            <div class="applyUserInfo">
                <dl>
                    <dt>申请人：</dt>
                    <!--已认证的主账号-->
                    <dd v-if="attestationInfo.identificationStatus == 1 && userInfo.userType=='ADMIN_ACCOUNT'">
                        <span>{{information.applyName}}</span>
                        <!-- 子账号不显示该图标 -->
                        <img src="@/assets/img/certified.png" alt="">
                    </dd>
                    <dd v-else>
                        <span>{{information.applyName}}</span>
                    </dd>
                </dl>
                <span class="goReal" v-if="userInfo.userType=='ADMIN_ACCOUNT' && attestationInfo.identificationStatus == 2" @click="goReal">去实名<van-icon name="arrow" /></span>
            </div>
        </div>
        <div class="addfileWrap" v-if="timeData.length === 0">
            <div class="addileArea" @click="chooseFile">
                <div class="addBtn">
                    <img src="@/assets/img/addfile.png" alt="">
                    <p>选择需要保护的文件</p>
                </div>
                <div class="mask" @click.stop="upTipDia=true,inputerClick=true" v-if="upTipShow && !upTipcCheck"></div>
            </div>
        </div>
        <div class="pageMain" ref="pageMain" v-if="timeData.length > 0">
            <div class="statement">
                <div class="form-item-tilte">
                    <h4>权利人</h4>
                    <b>多个权利人可用“;”分隔输入</b>
                </div>
                <div class="description owner">
                    <el-input
                        v-model="owner"
                        placeholder="请输入权利人姓名或单位名称"
                        @blur="ownerBlur"
                        @focus="ownerFocus"
                        maxlength="50"
                        show-word-limit
                    ></el-input>
                </div>

                <div class="form-item-tilte">
                    <h4>申请人自述声明</h4>
                    <span @click="template = true">自述声明模板</span>
                </div>
                <p class="error warning">为明确权利归属，请仔细确认下方自述声明内容是否真实完整，平台不对该内容进行审核。</p>
                <div class="description">
                    <el-input
                        type="textarea"
                        v-model="opusDescribe"
                        show-word-limit
                        class="mytextarea"
                        maxlength="300"
                    >
                    </el-input>
                    <div class="attention">
                        <p>1 自述声明内容模板仅供参考，您可根据具体情况自行修改；</p>
                        <p>2 申请人对申请认证的文件、权利人名称、自述声明承担全部责任，该信息将在《<strong class="timestampR gradientFont">可信时间戳<sup>&reg;</sup></strong>认证证书》上展示，平台不进行真实性审查、不承担相关法律责任。</p>
                    </div>
                </div>
            </div>

            <div class="fileList">
                <ul ref="fileListUl">
                    <li v-for="(item, index) in timeData" :key="index" :class="{'validate':item.modified,'disabled':item.solidifySuccess==1}">
                        <div class="file-icon">
                            <svg-icon :data_iconName="generateFileIcon(fileSuffix(item.opusName))" className="suffixIcon" />
                        </div>
                        <div class="form">
                            <div class="fileName">
                                <p>{{ item.opusName }}</p>
                                <i class="tsa-icon-edit2" @click="editName(item,index)" v-if="item.solidifySuccess !== 1" ></i>
                            </div>
                            <div class="fileType">
                                <label>保护类型：</label>
                                <span @click="openFileTypePop(item,index)">{{ item.fileType | fileTypeToText}} <van-icon name="arrow" v-if="item.solidifySuccess !== 1"  /></span>
                            </div>
                        </div>
                        <div class="delete">
                            <van-icon name="cross" @click="remove(index)" v-if="item.solidifySuccess !== 1" />
                        </div>
                        <div class="status">
                            <div class="shape gray" v-if="item.solidifySuccess==1 && item.isUploadFile && item.ossSliceUploadSuccess!==1">
                                <p>
                                    <span>已认证</span>
                                    <span>待上传原件</span>
                                </p>
                            </div>
                            <div class="shape green" v-if="(item.solidifySuccess==1 && !item.isUploadFile) || (item.isUploadFile && item.ossSliceUploadSuccess==1)">
                                <p>
                                    <span>已完成</span>
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="pageMain" v-else>
            <div class="explain">
                <template v-if="!(attestationInfo.identificationStatus !== 2 && userInfo.userType !=='AUTHORIZATION_ACCOUNT')">
                    <h3>提示：</h3>
                    <ul style="margin-bottom:20px">
                        <li>
                            <strong><van-icon name="info-o" /></strong>
                            <!-- 未实名的主账户 -->
                            <p v-if="(userInfo.userType !=='AUTHORIZATION_ACCOUNT' && attestationInfo.identificationStatus == 2)">
                                您尚未完成实名认证，证书上的“申请人”显示“账号信息”，实名后将显示“实名认证信息”。
                            </p>
                            <!-- 子账号判断 -->
                            <template v-if="userInfo.userType =='AUTHORIZATION_ACCOUNT'">
                                <p class="noRealName" v-if="showNameType==2">
                                    根据主账号的权限配置，申请人信息显示子账号名称。为保护主子账号的合法权益，您的“申请人”信息需重新设置，请联系主账号修改。
                                </p>
                                <p class="noRealName" v-else-if="showNameType==0">
                                    根据主账号的权限配置，申请人信息显示主账号名称，如需修改请联系主账号。
                                </p>
                                <p class="noRealName" v-else>
                                    根据主账号的权限配置，申请人信息显示主账号+子账号名称，如需修改请联系主账号。
                                </p>
                            </template>
                        </li>
                    </ul>
                </template>
                <h3>说明：</h3>
                <ul>
                    <li>
                        <strong>1.</strong>不限制文件格式和大小，即时颁发可信时间戳<sup>®️</sup>证书，立刻拥有具有法律效力的权属证明和数字产权凭证。
                    </li>
                    <li>
                        <strong>2.</strong><b>存证认证</b>：原文件上传到平台进行认证和存储，便于随时下载/查阅/分享，防止文件丢失/被更改。
                        <p><b>保密认证</b>：原文件不上传到平台，仅上传文件哈希值进行认证，确保文件内容绝对保密。原文件需自行妥善保存，不可有任何形式修改，否则无法通过验证。</p>
                    </li>
                    <li>
                        <strong>3.</strong>可信时间戳认证后文件不能有任何形式的修改和变化，否则无法通过可信时间戳<sup>®️</sup>验证。
                    </li>
                    <li v-if="!isOriginal && !isIOS">
                        <strong>4.</strong>限于系统特性，选择“<b>保密认证</b>”时若选择“<b>拍照或录像</b>”方式，<b>原文件会丢失</b>，请选择其他方式上传文件。
                    </li>
                </ul>
            </div>
        </div>
        <div class="fixBtn" v-if="timeData.length > 0">
            <span @click="goOnAdd"><van-icon name="plus" /> 继续添加文件</span>
            <span @click="send">申请可信时间戳</span>
        </div>
        <div class="upload-input"> 
            <input
                type="file"
                class="uploadfile"
                :accept="isIOS ? 'application/octet-stream':'*/*'"
                multiple="multiple"
                ref="inputer"
                @change="addfile"
            />
        </div>
        

        <!-- 脱敏提示框 -->
        <van-dialog v-model="upTipDia" title="重要提示" class="mydialogBox" confirmButtonColor="#008AFF" confirmButtonText="知道了" @confirm="closeDia">
            <div class="dialog_cnt">
                <div class="content">
                    <p class="tip" v-if="!isIOS">限于系统特性，选择“<b>保密认证</b>”时若选择“<b>拍照或录像</b>”方式，<b>原文件会丢失</b>，请选择其他方式上传文件。</p>
                    <p class="tip" v-else>若希望认证相册中的影像，请先在相册将该影像保存至“文件”系统APP。</p>
                    <p class="check-wrap"><van-checkbox v-model="upTipcCheck" @change="noDiaLog">不再弹出</van-checkbox></p>
                </div>
            </div>
        </van-dialog>

        <van-dialog
            title="申请人自述模板"
            v-model="template"
            class="tem-dialog"
            confirmButtonColor="#008AFF"
            confirmButtonText="关闭"
            @confirm="template==false"
        >
            <ul>
                <li class="tem-li">
                    <h3>我是拥有该文件的自然人/组织：</h3>
                    <div class="tem-cnt">
                        <p>
                        本作品/文件已经申请可信时间戳认证，「权利人名称」拥有该作品的著作权（包括但不限于发表权、署名权、修改权、保护作品完整权、复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权）和法律授予的其他权利，未经授权，任何单位和个人禁止以任何方式使用本作品/文件。
                        <span
                            @click="copy"
                            class="copybtn"
                            data-clipboard-text="本作品/文件已经申请可信时间戳认证，「权利人名称」拥有该作品的著作权（包括但不限于发表权、署名权、修改权、保护作品完整权、复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权）和法律授予的其他权利，未经授权，任何单位和个人禁止以任何方式使用本作品/文件。"><van-icon class-prefix="vant-ali-fuzhi" class="copyicon"/>
                        </span>
                        </p>
                    </div>
                </li>
                <li class="tem-li">
                    <h3>我和其他人共同拥有该文件：</h3>
                    <div class="tem-cnt">
                        <p>
                            本作品/文件已经申请可信时间戳认证，「权利人名称及XXX」共同拥有该作品的著作权（包括但不限于发表权、署名权、修改权、保护作品完整权、复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权）和法律授予的其他权利，未经授权，任何单位和个人禁止以任何方式使用本作品/文件。
                            <span
                                @click="copy"
                                class="copybtn"
                                data-clipboard-text="本作品/文件已经申请可信时间戳认证，「权利人名称及XXX」共同拥有该作品的著作权（包括但不限于发表权、署名权、修改权、保护作品完整权、复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权）和法律授予的其他权利，未经授权，任何单位和个人禁止以任何方式使用本作品/文件。"
                                ><van-icon class-prefix="vant-ali-fuzhi" class="copyicon"/>
                            </span>
                        </p>
                    </div>
                </li>
                <li class="tem-li">
                    <h3>替其他人申请，该文件归我的客户所有，但我是他的代理人：</h3>
                    <div class="tem-cnt">
                        <p>
                            本作品/文件已经申请可信时间戳认证，申请人作为代理人代为申请，权利属于「权利人名称」所有。
                            <span
                                @click="copy"
                                class="copybtn"
                                data-clipboard-text="本作品/文件已经申请可信时间戳认证，申请人作为代理人代为申请，权利属于「权利人名称」所有。"
                                ><van-icon class-prefix="vant-ali-fuzhi" class="copyicon"/>
                            </span>
                        </p>
                    </div>
                </li>
                <li class="ts tem-ts">
                    <p>1 自述声明内容模板仅供参考，您可根据具体情况自行修改；</p>
                    <p>2 申请人对自述声明内容承担全部责任，该内容将在《<strong class="timestampR gradientFont">可信时间戳<sup>&reg;</sup></strong>认证证书》上展示，平台不对申请人自述声明内容进行真实性审查、不承担相关法律责任。</p>
                </li>
            </ul>
        </van-dialog>

        <!-- 保护类型选择 -->
        <van-popup v-model="fileTypePop" round position="bottom" class="fileTypePop" safe-area-inset-bottom>
            <div class="popHeader">
                <h4>选择保护类型</h4>
                <van-icon name="cross" @click="fileTypePop=false" />
            </div>
            <div class="popBody">
                <span v-for="itemtype in fileType" :key="itemtype.name" :class="itemtype.value == currentFileItem.fileType ? 'myradio checkradio' : 'myradio'" @click="chooseType(itemtype)">{{itemtype.name}}</span>
                <span class="myradio radioOpcity" v-for="item in (Math.ceil( fileType.length / 3) * 3 - fileType.length)" :key="'key'+item"></span>
            </div>
            <div class="popFooter">
                <p>
                    <label>为所有文件统一选择该保护类型</label>
                    <van-switch v-model="unity" size="20px" />
                </p>
                <span class="btn" @click="setFileType">确定</span>
            </div>
        </van-popup>

        <!-- 编辑文件名 -->
        <van-popup v-model="editFileNamePop" round position="bottom" class="editFileNamePop" safe-area-inset-bottom>
            <div class="popHeader">
                <span @click="editFileNamePop=false">取消</span>
                <h4>修改文件名称</h4>
                <span :class="{'disable': !editFileName.trim() || editFileName.length > maxFileNameLength}" @click="setFileName">完成</span>
            </div>
            <div class="popBody">
                <input :class="{'validate': editFileName.length > maxFileNameLength}" ref="fileNameInputer" v-model="editFileName" placeholder="请输入自定义名称" />
                <div class="limit">
                    <p class="red">{{!editFileName.trim() ? '文件名称不能为空' : (editFileName.length > maxFileNameLength ? `请输入${maxFileNameLength}个字符以内的文件名称` : '')}}</p>
                    <span><b :class="{'red': editFileName.length > maxFileNameLength }">{{ editFileName.length }}</b>/{{ maxFileNameLength }}</span>
                </div>
            </div>
        </van-popup>


        <!-- 固化弹窗 -->
        <TsaProgressPopUp
            title="正在申请可信时间戳认证"
            ref="solidifyProgressPopUp"
            v-model="opusFilePopup"
            :fileStatus="{
                'waiting': '待认证',
                'processing': '正在认证',
                'success': '认证成功',
                'fail': '认证失败',
                'showResult': '已认证成功',
                'fileDamage': '认证失败',
                'realName':'认证失败',
            }"
            percentage="solidifyPercentage"
            success="solidifySuccess"
            width="95%"
            :listData="timeData"
            :uploadSuccessNumber="opusFileUploadSuccessNumber"
            :AllUploadNumber="opusFileAllUploadNumber"
            @on-stop="opusFilePopupStop"
        />
        
        <van-dialog v-model="opusFileProgressPopupCancelShow" title="提示" class="mydialogBox" show-cancel-button confirmButtonColor="#008AFF" confirmButtonText="确认" cancelButtonText="取消" @confirm="opusFileProgressPopupConfirm" @cancel="opusFileProgressPopupCancel">
            <div class="dialog_cnt">
                <div class="content">
                    <p>关闭后“未认证成功”的文件将不再继续认证，是否确认返回修改</p>
                </div>
            </div>
        </van-dialog>

        <TsaProgressPopUp
            title="正在进行存储"
            ref="ossSliceUploadProgressPopUp"
            v-model="ossUploadPopup"
            :isUpFile="true"
            :fileStatus="{
                waiting: '待上传',
                processing: '正在上传',
                success: '存证成功',
                fail: '存证失败',
                showResult: '已上传成功',
            }"
            percentage="ossSliceUploadPercentage"
            success="ossSliceUploadSuccess"
            width="95%"
            :listData="timeData"
            :uploadSuccessNumber="ossSliceUploadSuccessNumber"
            :AllUploadNumber="ossSliceAllUploadNumber"
            @on-stop="ossUploadPopupStop"
        />

        <van-dialog v-model="ossUploadProgressPopupCancelShow" title="提示" class="mydialogBox" show-cancel-button confirmButtonColor="#008AFF" confirmButtonText="确认" cancelButtonText="取消" @confirm="ossUploadProgressPopupConfirm" @cancel="ossUploadProgressPopupCancel">
            <div class="dialog_cnt">
                <div class="content">
                    <p>关闭后“未上传成功”的文件将不再继续上传，是否确认返回修改</p>
                </div>
            </div>
        </van-dialog>

        <!-- 结束认证确认框 -->
        <van-dialog v-model="confirmBox" title="提示" class="mydialogBox" confirmButtonColor="#008AFF" confirmButtonText="确认" show-cancel-button cancelButtonText="取消" @confirm="overAttestation">
            <template #title>
                <van-icon name="warning"/>
            </template>
            <div class="dialog_cnt">
                <div class="content">
                    <p>当前已完成<b style="color:red;margin:0 10px">{{this.overNum}}</b>个文件的认证，结束认证后剩余的文件将无法认证，未认证已扣除的时间戳将在24小时内返回到您的账户中，是否确定结束认证</p>
                </div>
            </div>
        </van-dialog>
        <!-- 上传源文件充值带关闭提示框 -->
        <van-dialog 
            v-model="buyDialog" 
            class="buyDialog" 
            :confirmButtonColor="buyDialogCnt.confirmButtonColor"
            :confirmButtonText="buyDialogCnt.confirmButtonText"
            show-cancel-button
            :cancelButtonText="buyDialogCnt.cancelButtonText"
            :before-close="openbuy"
        >
            <template #title>
                <div class="headerDialog">
                    <h3>{{buyDialogCnt.title}}</h3>
                    <van-icon name="cross" class="close" @click="close" />
                </div>
            </template>
            <div class="dialog_cnt">
                <div class="content">
                    <p>{{buyDialogCnt.message}}</p>
                </div>
            </div>
        </van-dialog>

        <!-- 申请确认框 -->
         <van-dialog
            title=""
            v-model="confirmDia"
            class="tem-dialog"
            show-cancel-button
            cancelButtonText="取消"
            confirmButtonColor="#008AFF"
            confirmButtonText="确认申请"
            :before-close="beforeClose"
        >
            <div class="applyConfirm">
                <dl class="form-item" v-if="ossSliceAllUploadNumber>0">
                    <dt>
                        选择存储时长：
                    </dt>
                    <dd :class="{'noyear':storageYearValue===0}">
                        <div class="input-wrap2" @click.stop="chooseYearsPicker=true">
                            <p>{{ storageYearValue===0 ? '自定义': storageYear+'年' }}</p>
                            <van-icon name="arrow-down" class="arrow" />
                        </div>
                        <div class="input-wrap" v-if="storageYearValue===0">
                            <input type="number" v-model="storageYear" @change="changeStorageYearNum" @input="handleInputNum" @blur="handleInputNumBlur" />
                            <span>年</span>
                        </div>
                    </dd>
                </dl>
                <div class="fileInfo">
                    共<b>{{ timeData.length }}</b>个文件，消耗时间戳总数：<b>{{ TotalTimestampsCount }}</b>个
                </div>
                <div class="readRule">
                    <div class="readBox">
                        <h5><van-checkbox v-model="checked" shape="square">我已阅读并同意以下内容：</van-checkbox></h5>
                        <p v-if="ossSliceAllUploadNumber>0">
                            <b>1.</b><span>保密认证的文件仅收取基础认证费，存证认证的文件收取基础认证费和文件存储费。详细的收费标准，请您参阅<a @click="showRules">计费规则</a>。</span>
                        </p>
                        <p v-else>
                            <span>保密认证的文件仅收取基础认证费。详细的收费标准，请您参阅<a @click="showRules">计费规则</a>。</span>
                        </p>
                        <p v-if="ossSliceAllUploadNumber>0">
                            <b>2.</b><span> 存证认证文件后续收费规则：您存证认证的文件，将在本次存储期满后自动按每年<strong>{{DeductionTimestampsCount}}个时间戳</strong>的标准收取后续存储费用。如扣费时您的时间戳账户余额不足，平台将关闭该存证认证文件下载权限，如需恢复下载权限，请在时间戳账户充值，平台自动扣除存储所需费用。如存证认证文件不再需要平台存储，可在平台上删除存证认证文件，删除后平台不再收取存储费用（建议删除前将存证认证文件下载到本地妥善保存，不可有任何形式修改，否则将无法通过<strong class="timestampR gradientFont">可信时间戳<sup>&reg;</sup></strong>验证，原申请的《<strong class="timestampR gradientFont">可信时间戳<sup>&reg;</sup></strong>认证证书》长期有效）。</span>
                        </p>
                    </div>
                </div>
            </div>
        </van-dialog>
        <van-popup v-model="chooseYearsPicker" position="bottom">
            <van-picker
                title="存储年限"
                show-toolbar
                value-key="title"
                :columns="storageYearList"
                @confirm="onChooseYears"
                @cancel="chooseYearsPicker = false"
            />
        </van-popup>

        <BillingRules ref="billingRules" />
    </div>
</template>

<script>
import { hashFile, hashMd5File } from '@/utils/fileHash'
import {filterParams , generateUUID} from '@/utils/filter'
import { encrypt } from '@/utils/aes.js'
import { debounce } from '@/utils/utils.js'
import { mapState } from 'vuex'
import {opusUserInfo,opusUpdateUserInfo,opusApply,findBalance,me,user,generateStsUploadSignMessage,completeStatus,lengthCount,cancelStsUpload,storeCount} from '@/api/service'
import { ExcludeRequest400 } from '@/api/index.js'
import { ossMultipartUpload,ossAbortMultipartUpload} from '@/utils/ossMultipartUpload'
import TsaProgressPopUp from '@/components/ApplyTime/TsaProgressPopUp'
import { fileType } from '@/config/copyright/categorysList'
import { parseUA,splitByKeyword } from '@/common/utils.js'
import SensitiveTextarea from '@/components/SensitiveTextarea'
import {fileSuffix,generateFileIcon} from '@/utils/utils'
import BillingRules from '@/components/BillingRules.vue'
var interval = null;
export default {
    data() {
        return {
            submitting: false,//防止重复提交
            inputerClick:true,//开关
            upTipcCheck:false,
            upTipDia:false,//脱敏上传提示
            rulesUrl:process.env.VUE_APP_ACCOUNTUI+'/userAccount/norm',
            pattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            isOriginal:true,
            beforText:'',
            afterText:'',
            owner:'',
            oldOwner:'',//保存之前输入的权利人
            ownerSyncWithApplicant: true, // 权利人是否跟随申请人同步，用户手动修改后设为false
            opusDescribe: '',//自述声明
            opusDescribeText:'本作品/文件已经申请可信时间戳认证，「权利人名称」拥有该作品的著作权（包括但不限于发表权、署名权、修改权、保护作品完整权、复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权）和法律授予的其他权利，未经授权，任何单位和个人禁止以任何方式使用本作品/文件。',//自述声明文案
            fileTypePop:false,
            fileType,
            currentFileItem:{},
            currentFileIndex:'',
            editFileNamePop:false,
            editFileName:'',
            editFileExtension:'', // 文件后缀
            editFileIndex:'',
            timeData:[],
            //选择文件相关
            attestationInfo:{},
            information: {
                applyName: '',
                applyIdType: '',
                applyIdNumber: '',
            },
            showNameType:'',
            fil: {},
            files: [],
            zhe: false,
            percentage: 0,
            totalSize: 0,
            unity: false, //统一编辑
            template: false, //自述模板
            confirmBox:false,//结束认证确认框
            active: 0, //当前状态
            overNum:0,//已认证完成的文件数
            result: [],//不上传文件进度数据
            serialNos: [],
            buyDialog:false,
            buyDialogCnt:{
                message:'sadasdasddas',
                title:'提示',
                confirmButtonColor:"#008AFF",
                confirmButtonText:"去充值", 
                cancelButtonText:"我已充值",
            },

            currentIndex:0,//当前计算hash的索引
            opusFilePopup: false, // 固化文件进度弹窗
            ossUploadPopup: false, // 存证 上传到oss的进度弹窗
            opusFileProgressPopupCancelShow: false,
            ossUploadProgressPopupCancelShow: false,
            ossUploadProgressPopupCancelDisabled: false,
            allowSolidification:true,//是否允许固化
            allowExistingEvidence: true,//是否允许存证
            tsCount:1,
            TotalTimestampsCount: 0,//当前扣除的时间戳总数
            solidifyCount:0,//固化扣除的时间戳总数
            existingEvidenceCount:0,//存证扣除的时间戳总数
            //新增确认弹框区域
            confirmDia:false,
            storageYear: 3,//存储年限
            storageYearValue:3,//存储年限选择值
            DeductionTimestampsCount:0,//存证到期后自动扣除的时间戳数
            checked:false,//是否同意
            chooseYearsPicker:false,
            storageYearList:[
                {title:'1年', value:1},
                {title:'2年', value:2},
                {title:'3年', value:3},
                {title:'5年', value:5},
                {title:'8年', value:8},
                {title:'10年', value:10},
                {title:'自定义', value:0},
            ],
            parseUA:'',
        };
    },

    components: {TsaProgressPopUp,SensitiveTextarea,BillingRules},

    watch:{
        stepsActive (newVal, oldVal) {
            this.btnFix=false;
        },
        opusFilePopup (val) { // 有改动
            if (!val) {
                this.opusFileProgressPopupCancelShow = false
                this.submitting = false
            }
        },
        ossUploadPopup (val) { // 有改动
            if (!val) {
                this.ossUploadProgressPopupCancelShow = false
                this.submitting = false
            }
        },
        // 申请人名称变化时，权利人跟随同步（仅在用户未手动修改权利人时）
        'information.applyName'(newVal) {
            if (this.ownerSyncWithApplicant && newVal) {
                this.oldOwner = this.owner
                this.owner = newVal
                this.ownerBlur();
            }
        },
        // 监听权利人值变化：当值不再等于申请人名称时，视为用户手动修改，断开同步
        owner(newVal) {
            if (this.ownerSyncWithApplicant && newVal !== this.information.applyName) {
                this.ownerSyncWithApplicant = false
            }
        }
    },

    computed: {
        isIOS() {
            const ua = parseUA()
            return ua.iPhone || ua.iPad || ua.ios
        },
        // 计算当前编辑文件的最大文件名长度（总长度100 - 后缀长度）
        maxFileNameLength() {
            const extensionLength = this.editFileExtension ? this.editFileExtension.length : 0
            return 100 - extensionLength
        },
        ...mapState({
            parentIframe: (state) => state.app.parentIframe,
        }),
        userInfo: {
            get() {
                return this.$store.state.userInfo.userInfo
            },
            set(val) {
                this.$store.state.userInfo.userInfo = val
            },
        },
        access_token(){
            return this.$store.state.userInfo.me.accessToken
        },
        // 固化时候的成功的数量
        opusFileUploadSuccessNumber () {
            let array = this.timeData.filter(item => {
                return item.solidifySuccess === 1
            })
            return array.length
        },
        // 固化时候的总数量 (既全量)
        opusFileAllUploadNumber () {
            return this.timeData.length
        },
        // 分片上传成功的数量
        ossSliceUploadSuccessNumber () {
            let array = this.timeData.filter(item => {
                return item.ossSliceUploadSuccess === 1 && this.isOriginal===true
            })
            return array.length 
        },
        // 分片上传时候的总数量
        ossSliceAllUploadNumber () {
            if(this.isOriginal){
                return this.timeData.length
            }else{
                return 0
            }
        },
        upTipShow(){
            if(this.isIOS){
                return true
            }else{
                return this.isOriginal ? false : true
            }
        }
    },

    created() {
        this.opusDescribe=this.opusDescribeText
        this.upTipcCheck=this.$getlocalStorage('applyNoDia')
        this.getUserInfo();
        this.parseUA=parseUA();
    },

    destroyed(){
        clearInterval(interval);
    },

    methods:{
        showRules(){
            this.$refs.billingRules.open()
        },
        fileSuffix(name){
            return fileSuffix(name)
        },
        generateFileIcon (row) {
            return generateFileIcon(row)
        },
        closeDia(){
            if(this.inputerClick){
                this.$refs.inputer.click();
            }
        },
        noDiaLog(e){
            this.$setlocalStorage("applyNoDia",e)
        },
        goRecharge(){
            switch (this.parentIframe) {
                case 'ANDROID-RIGHTS':
                    window.testInterface.jumpNativeRecharg(JSON.stringify({copyright:1}));
                    break
                case 'IOS-RIGHTS':
                    window.webkit.messageHandlers.jumpNativeRecharg.postMessage({ copyright:1 });
                    break
                case 'HARMONYOSNEXT-RIGHTS':
                    window.nativeMethod.pushPage('RechargePage', {redirectUrl: 'BannerWebviewPage'});
                    break
                case 'WEIXIN':
                    window.location.href=process.env.VUE_APP_ACCOUNTUI + `/userAccount/buy?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType'):0}`
                    break
                default:
                    this.$router.push({
                        path:'/mine/Account',
                        query:{
                            url:process.env.VUE_APP_ACCOUNTUI+`/userAccount/buy?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')?this.$getlocalStorage('partnerType'):0}`
                        }
                    })
            }
        },
        delay (time) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve()
                }, time)
            })
        },
        // 获取用户信息
        async getUserInfo(retrunApplyName=false) {
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await opusUserInfo()
                    this.attestationInfo = res;
                    this.showNameType=res.showNameType;
                    // 先拉取最新用户数据，防止缓存数据过期
                    await this.$store.dispatch('userInfo/fetchUserInfo')
                    //子账号
                    if(this.userInfo.userType =='AUTHORIZATION_ACCOUNT'){
                        let applyName;
                        if(res.identificationStatus !== 2){//主实名
                            applyName=res.applyName
                        }else{
                            if(res.showNameType==0){//显示主
                                applyName=this.userInfo.masterAccount
                            }else if(res.showNameType==1){//显示主+子
                                applyName=this.userInfo.masterAccount+'-'+this.userInfo.ownerName
                            }else{//2.子
                                applyName=this.userInfo.ownerName
                            }
                        }
                        retrunApplyName ? resolve({applyName}) : this.information = {
                            applyName,
                        }
                        
                    }else{
                        //主账号用户未实名的
                        if(res.identificationStatus == 2){
                            retrunApplyName ? resolve({applyName:this.userInfo.loginName}) : this.information = {
                                applyName: this.userInfo.loginName
                            }
                        }else{
                            retrunApplyName ? resolve({applyName:res.applyName}) : this.information = {
                                applyName: res.applyName,
                                applyIdType: res.applyIdType,
                                applyIdNumber: res.applyIdNumber,
                            }
                        }
                    }
                    if(retrunApplyName){
                        return
                    }
                    this.owner=this.information.applyName;
                    this.ownerBlur();
                } catch (error) {
                    console.log(error)
                    reject()
                }
                
            })
        },
        fileNameValidate(val){
            return val.length<=100
        },
        tabOriginal(n){
            if(this.opusFileUploadSuccessNumber==0){
                //当前已经有选择好了得文件
                if(this.timeData.length>0 && n==2 && this.isOriginal==true && !this.isIOS){
                    this.upTipDia=true;
                    this.inputerClick=false;
                }
                n==1 ? this.isOriginal=true : this.isOriginal=false
            }else{
                this.$toast(`检测到当前已有固化成功的文件，不可再修改认证方式。`)
            }
        },
        goReal(){
            let userAgent = navigator.userAgent.toLowerCase();
            if(userAgent.indexOf('micromessenger') !== -1) {//当前页面在微信中打开
                window.location.href=process.env.VUE_APP_ACCOUNTUI+`/userCenter/AuthenticationName/userCenter/AuthenticationName?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType') : 0}`
            }else{
                this.$router.push({
                    path:'/mine/Account',
                    query:{
                        url:process.env.VUE_APP_ACCOUNTUI+`/userCenter/AuthenticationName?sourceType=952310&clientId=952310&access_token=${this.access_token}&partnerType=${this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType') : 0}`
                    }
                })
            }
        },
        goOnAdd(){
            if(this.upTipShow && !this.upTipcCheck){
                this.upTipDia=true;
                this.inputerClick=true
            }else{
                this.chooseFile()
            }
        },
        chooseFile(){
            this.$refs.inputer.value=null;
            this.$refs.inputer.click();
        },
        addfile(n){
            let inputDOM = this.$refs.inputer;
            this.fil = inputDOM.files
            if (this.fil.length == 0) {
                return false
            }
            let obj
            for (let i = 0; i < this.fil.length; i++) {
                if(Math.floor(this.fil[i].size==0)){
                    this.$toast(`文件${this.fil[i].name}大小为0kb，无法确权，已为您从列表移除。`)
                    return false
                }
                obj = {
                    fileItem: this.fil[i],
                    opusName: this.fil[i].name,
                    owner:'',
                    opusDescribe: '',
                    fileType: 999,
                    modified: false,
                    percentage: 0,
                    opusApplyType:2,
                    isUploadFile:this.isOriginal,
                    //新版增加
                    id:'',
                    uuid: generateUUID(),
                    serialNo:'',
                    solidifyPercentage: 0, // 固化上传百分比百分比
                    solidifySuccess: 0, // 是否固化完成 // 0 未完成， 1 成功， 2 固化失败
                    ossSliceUploadPercentage: 0, // 分片上传百分比
                    ossSliceUploadSuccess: 0, // 是否分片上传完成 // 0 未完成， 1 成功， 2 上传失败
                    applyFileSize: this.fil[i].size, // 文件的大小，用来进行存证扣费用的
                    years:this.storageYear? this.storageYear : 3 // 存储年限
                }
                this.totalSize += Math.floor(this.fil[i].size)
                this.timeData.push(obj)
            }
            // this.$nextTick(() => {
            //     const pageMain = this.$refs.pageMain
            //     if (pageMain) {
            //         pageMain.scrollTop = pageMain.scrollHeight
            //     }
            // })
        },

        editName(item,index){
            // 提取文件后缀
            const lastDotIndex = item.opusName.lastIndexOf('.')
            let fileName = item.opusName
            let extension = ''

            if (lastDotIndex !== -1) {
                fileName = item.opusName.substring(0, lastDotIndex)
                extension = item.opusName.substring(lastDotIndex)
            }

            this.editFileName = fileName
            this.editFileExtension = extension
            this.editFileindex = index
            this.editFileNamePop = true
            this.$nextTick(()=>{
                this.$refs.fileNameInputer.focus();
            })
        },
        setFileName(){
            // 文件名称不能为空
            if(!this.editFileName.trim()){
                this.$toast('文件名称不能为空')
                return
            }
            // 校验长度时需要包含后缀，使用动态计算的最大长度
            const fullName = this.editFileName + (this.editFileExtension || '')
            if(fullName.length > 100){
                return
            }
            this.timeData[this.editFileindex].modified = false
            this.timeData[this.editFileindex].opusName = fullName
            let obj = this.timeData[this.editFileindex]
            this.$set(this.timeData, this.editFileindex, obj)
            this.$nextTick(()=>{
                this.editFileNamePop = false
            })
        },

        openFileTypePop(item,index){
            if(item.solidifySuccess == 1) return
            this.currentFileItem=item;
            this.currentFileIndex=index;
            this.fileTypePop=true;
        },
        chooseType(item){
            this.currentFileItem.fileType=item.value;
        },
        setFileType() {
            if (this.currentFileItem.solidifySuccess == 1){
                return false
            }
            if (this.unity) {
                this.timeData.forEach((v, i) => {
                    if(v.solidifySuccess !== 1){
                        v.fileType = this.currentFileItem.fileType
                        this.$set(this.timeData, i, v)
                    }
                })
                this.fileTypePop=false;
                return false
            }
            this.timeData[this.currentFileIndex].fileType = this.currentFileItem.fileType
            let obj = this.timeData[this.currentFileIndex]
            this.$set(this.timeData, this.currentFileIndex, obj)
            this.fileTypePop=false;
        },
        remove(index) {
            this.timeData.splice(index, 1)
            this.$refs.inputer.value = null;
            if(this.timeData.length === 0){
                this.oldOwner = '';
                this.beforText = '';
                this.afterText = '';
                this.opusDescribe = this.opusDescribeText;
                this.owner = this.information.applyName;
                this.ownerSyncWithApplicant = true; // 重置同步标志
                this.ownerBlur();
                // this.isOriginal=true;
                this.unity=false; //统一编辑
                this.checked=false; //上传源文件
                this.storageYear= 3;//存储年限
                this.storageYearValue=3;//存储年限选择值
                //this.getUserInfo();
            }
        },
        ownerFocus(){
            this.oldOwner = this.owner
            if(this.owner){
                let result= splitByKeyword(this.opusDescribe,'「权利人名称」')
                if(result.length>0){
                    let index= result.findIndex(item => 
                        item.before.endsWith(this.beforText) && item.after.startsWith(this.afterText)
                    )
                    if(index==-1) return
                    this.oldOwner=''
                }
            }
        },
        ownerBlur(){
            if(this.owner && this.opusDescribe){
                let result1 = splitByKeyword(this.opusDescribeText,'「权利人名称」')
                if(!result1.length) return;
                this.beforText=result1[0].before;
                this.afterText=result1[0].after;
                if(this.oldOwner=='') this.oldOwner='「权利人名称」'; 
                let result2= splitByKeyword(this.opusDescribe,this.oldOwner)
                if(result2.length>0){
                    let index= result2.findIndex(item => 
                        item.before.endsWith(this.beforText) && item.after.startsWith(this.afterText)
                    )
                    if(index==-1) return
                    if(result2[index].keyword==this.oldOwner ){
                        this.opusDescribe=(result2[index].before+this.owner+result2[index].after)
                    }
                }
            }
            if(this.owner==='' || this.owner.trim() === ''){
                if(this.oldOwner && this.oldOwner !== '「权利人名称」' && this.opusDescribe){
                    let result = splitByKeyword(this.opusDescribe, this.oldOwner)
                    if(result.length > 0){
                        let index = result.findIndex(item =>
                            item.before.endsWith(this.beforText) && item.after.startsWith(this.afterText)
                        )
                        if(index !== -1){
                            this.opusDescribe = result[index].before + '「权利人名称」' + result[index].after
                        }
                    }
                }
            }
        },


        // 计算所需的时间戳
        calculateTheRequiredTimestamp (callback) {
            return new Promise(async(resolve, reject) => {
                try {
                    let list = []
                    let TotalTimestampsCount = 0 // 总共的时间戳数量
                    let solidifyCount = this.timeData.filter(item => {
                        // return (item.storeType === 'DESENSITIZE_STORE' && !item.id) || (item.storeType === 'SAVE_STORE' && item.solidifySuccess !== 1)
                        return item.solidifySuccess !== 1
                    }).length // 需要固化的时间戳数量

                    let existingEvidenceCount = 0 // 存证的时间戳数量
                    this.timeData.map(item => {
                        if (this.isOriginal && !item.id) {
                            list.push({
                                "key": item.uuid,
                                "fileSize": item.applyFileSize,
                                "keyType": 0,
                                "years": item.years
                            })
                        }
                    })
                    let { tsCount, resultList } = await lengthCount(list)
                    // 计算固化所需要的时间戳
                    solidifyCount = parseInt((tsCount * solidifyCount).toFixed(0))
                    // 计算存证所需要的时间戳
                    resultList && resultList.map(item => {
                        existingEvidenceCount = parseInt((existingEvidenceCount + item.storeCount).toFixed(0)) // 每一次最好取证计算
                    })
                    // 计算时间戳总数
                    TotalTimestampsCount = parseInt((solidifyCount + existingEvidenceCount).toFixed(0))
                    resolve(TotalTimestampsCount)
                } catch (error) {
                    reject(error)
                    callback && callback()
                    
                }
            })
        },
        //计算当前应扣减的时间戳数量，用于判断余额是否够用
        getAccountNum(){
            let TotalTimestampsCount = 0 // 总共的时间戳数量
            let solidifyCount = this.timeData.length // 固化的时间戳数量
            let existingEvidenceCount = 0 // 存证的时间戳数量
            let solidifySuccessCount=0 //已固化完成的时间戳数量
            let existingEvidenceSuccessCount=0 //已存证完成的时间戳数量
            // 计算固化所需要的时间戳
            solidifyCount = parseInt((this.tsCount * solidifyCount).toFixed(0))
            // 计算存证所需要的时间戳
            this.timeData.map(item => {
                if(item.solidifySuccess==1){
                    solidifySuccessCount=parseInt((solidifySuccessCount + 1).toFixed(0))
                }
                if(item.ossSliceUploadSuccess==1){
                    existingEvidenceSuccessCount=parseInt((existingEvidenceSuccessCount + item.storeCount).toFixed(0))
                }
                existingEvidenceCount = parseInt((existingEvidenceCount + item.storeCount).toFixed(0)) // 每一次最好取证计算
            })
            // 计算时间戳总数
            TotalTimestampsCount = parseInt((solidifyCount + existingEvidenceCount).toFixed(0))
            //计算应该扣费的时间戳总数
            let deductTimestampsCount=TotalTimestampsCount-existingEvidenceSuccessCount-solidifySuccessCount
            return deductTimestampsCount
        },
        async send(){
            let that=this;
            this.errorInfo=false;
            if (!this.information.applyName) {
                this.$toast("请填写申请人姓名");
                return false;
            }
            if (this.information.applyName.length>50) {
                this.$toast("申请人信息需少于50个字");
                return false;
            }

            if(!this.owner || this.owner.trim() === ''){
                this.$toast('请输入权利人姓名或单位名称')
                this.$refs.pageMain.scrollTop=0;
                return
            }
            if(this.owner.length > 50){
                this.$toast('权利人姓名不能超过50个字符')
                this.$refs.pageMain.scrollTop=0;
                return
            }
            if(!this.opusDescribe || this.opusDescribe.trim() === ''){
                this.$toast('请输入申请人自述声明')
                this.$refs.pageMain.scrollTop=0;
                return
            }
            if(this.opusDescribe.length>300){
                this.$message.error('申请人自述声明不能超过300字')
                return
            }
            let P1=()=>{
                return new Promise((resolve, reject) => {
                    let count = 0;
                    let countIndexArray=[];
                    for (let i = 0; i < that.timeData.length; i++) {
                        if(that.timeData[i].modified){
                            that.timeData[i].modified = false;
                        }
                        if (that.timeData[i].opusName.length > 100) {
                            count++;
                            countIndexArray.push(i);
                            that.timeData[i].modified = true;
                        }
                        that.$set(that.timeData, i, that.timeData[i])
                        if (i == (that.timeData.length - 1)) {
                            if (count > 0) {
                                resolve(countIndexArray)
                            }
                            resolve(countIndexArray);
                        }
                    }
                })
            }
            P1().then(async (countIndexArray)=>{
                if(countIndexArray.length>0){
                    this.$toast('文件名最多支持100字符,请修改');
                    this.$nextTick(() => {
                        const targetRow=this.$refs.fileListUl.querySelector(`li:nth-child(${countIndexArray[0]+1})`)
                        if (targetRow) {
                            targetRow.scrollIntoView({ behavior: 'smooth', block: 'start' })
                        }
                    });
                    return
                };
                //子账号需要获取最新状态，防止在当前申请期间主账号修改其权限信息等内容。
                if(that.$store.state.userInfo.userInfo.userType=='AUTHORIZATION_ACCOUNT'){
                    user().then((res) => {
                        if (res.forbidden) { 
                            that.$dialog.confirm({
                                title:'提示', 
                                message:'您无权使用该服务，请与主账号管理员联系授权', 
                                confirmButtonColor:'#008AFF',
                                confirmButtonText: '确定',
                            }).then(()=>{
                                window.location.href = process.env.VUE_APP_ACCOUNTUI
                            })
                            return false
                        }
                        that.$store.commit('userInfo/setUserInfo', res);
                    }).catch((err) => {
                        console.log(err)
                    });
                }
                try {
                    that.information=filterParams(that.information);
                    await opusUpdateUserInfo(that.information);
                    let paramsData=[];
                    this.timeData.forEach((v, i) => {
                        v.isUploadFile=this.isOriginal;
                        paramsData.push({
                            keyType:0,
                            fileSize:v.applyFileSize,
                            key:v.uuid,
                            years: v.years,
                        })
                    })
                    let res=await lengthCount(paramsData)
                    this.tsCount=res.tsCount;
                    let resultList=res.resultList;
                    let P2=()=>{
                        return new Promise((resolve, reject)=> {
                            that.timeData.forEach((v, i) => {
                                let data = resultList.find(i => v.uuid == i.key)
                                v = { ...v, ...that.information,storeCount:this.isOriginal? data.storeCount : 0,};
                                that.$set(that.timeData, i, v);
                            });
                            resolve();
                        })
                    }
                    P2().then(async()=>{
                        //获取当前文件的所需时间戳个数
                        this.getConsumptionTimestampsCount();
                        this.confirmDia=true;
                    })
                } catch(error) {
                    console.log(error)
                }
            })
        },
        //计算当前提交去掉已存证的剩下的应扣减的时间戳数量详细，用于存证申请提示告知弹框。
        getConsumptionTimestampsCountInfo() {
            return new Promise(async (resolve, reject) => {
                try {
                    let list = []
                    let list2 = []
                    let TotalTimestampsCount = 0 // 总共的时间戳数量
                    let solidifyCount = this.timeData.filter(item => {
                        return item.solidifySuccess !== 1
                    }).length // 需要固化的时间戳数量
                    let existingEvidenceCount = 0 // 存证的时间戳数量
                    this.timeData.map(item => {
                        //所需要的时间戳参数（扣费用的，只计算未成功的，已成功扣费的不算）
                        if (this.isOriginal && !item.id) {
                            list.push({
                                "key": item.uuid,
                                "fileSize": item.applyFileSize,
                                "keyType": 0,
                                "years": item.years
                            })
                        }
                        //当前所有文件到存证期后需要的存储费用的参数（总数，包含已成功的和未成功的）是每年的续费所以不用传years
                        if (this.isOriginal) {
                            list2.push({
                                "key": item.uuid,
                                "fileSize": item.applyFileSize,
                                "keyType": 0,
                            })
                        }
                    })
                    let {tsCount, resultList} = await lengthCount(list)
                    let {tsCount:DeductionTimestampsCount} = await storeCount(list2);
                    // 计算固化所需要的时间戳
                    solidifyCount = parseInt((tsCount * solidifyCount).toFixed(0))
                    // 计算存证所需要的时间戳
                    resultList && resultList.map(item => {
                        existingEvidenceCount = parseInt((existingEvidenceCount + item.storeCount).toFixed(0)) // 每一次最好取证计算
                    })
                    // 计算时间戳总数
                    TotalTimestampsCount = parseInt((solidifyCount + existingEvidenceCount).toFixed(0))
                    resolve({ TotalTimestampsCount,solidifyCount,existingEvidenceCount,DeductionTimestampsCount})
                } catch (error) {
                    reject(error)
                    callback && callback()
                }
            })
        },
        async getConsumptionTimestampsCount(){
            let {TotalTimestampsCount,solidifyCount,existingEvidenceCount,DeductionTimestampsCount} = await this.getConsumptionTimestampsCountInfo();
            this.DeductionTimestampsCount=DeductionTimestampsCount;
            this.TotalTimestampsCount=TotalTimestampsCount;
            console.log(TotalTimestampsCount)
            this.solidifyCount=solidifyCount;
            this.existingEvidenceCount=existingEvidenceCount;
        },
        // 根据年限改变timeData的数据
        async changeTimeDataYear(){
            let paramsData = [];
            //为未存证成功的文件改变年限
            this.timeData.forEach(item => {
                if(this.isOriginal && item.ossSliceUploadSuccess!== 1){
                    item.years=this.storageYear;
                    paramsData.push({
                        keyType: 0,
                        fileSize: item.applyFileSize,
                        key: item.uuid,
                        years: item.years,
                    })
                }
            });
            //重新计算未存证成功的文件存储费
            try {
                let res = await lengthCount(paramsData)
                this.tsCount = res.tsCount;
                let resultList = res.resultList;
                this.timeData = this.timeData.map((item, index) => {
                    let data = resultList.find(i => item.uuid == i.key)
                    if(data){
                        return {
                            ...item,
                            storeCount: this.isOriginal ? data.storeCount : 0,
                        }
                    }else{
                        return item
                    }
                })
                let solidifyCount = this.timeData.filter(item => {
                    return item.solidifySuccess !== 1
                }).length // 需要固化的时间戳数量
                let existingEvidenceCount = 0 // 存证的时间戳数量
                // 计算固化所需要的时间戳
                this.solidifyCount = parseInt((this.tsCount * solidifyCount).toFixed(0))
                // 计算存证所需要的时间戳
                resultList && resultList.map(item => {
                    existingEvidenceCount = parseInt((existingEvidenceCount + item.storeCount).toFixed(0)) // 每一次最好取证计算
                })
                this.existingEvidenceCount=existingEvidenceCount;
                // 计算时间戳总数
                this.TotalTimestampsCount = parseInt((this.solidifyCount + existingEvidenceCount).toFixed(0))
                
            } catch (error) {
                console.log(error)
            }
        },
        onChooseYears(item,key){
            this.storageYearValue=item.value;
            if(item.value!==0){
                this.storageYear=item.value;
                this.changeTimeDataYear();
            }
            this.chooseYearsPicker=false;
        },

        async submit(){
            if (this.submitting) return;
            let that=this;
            //获取最新实名信息
            this.submitting = true;
            try {
                let applyInfo = await this.getUserInfo(true)
                if(applyInfo.applyName !== this.information.applyName){
                    this.information.applyName = applyInfo.applyName;
                    this.confirmDia = false;
                    this.$dialog.alert({
                        title: '提示',
                        message: '申请人关联实名状态/信息已变更，请确认最新信息后再次申请认证',
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '去确认',
                    })
                    return
                }
            } catch (error) {
                return
            }

            try {
                // this.opusFilePopup=true;
                let res = await findBalance(this.getAccountNum());
                if (res.deductible == 1) {
                    await this.fileStart({ solidifyType: 1 }) //第一个弹框脱敏认证
                    await this.existingEvidence({ existingEvidenceType: 1}) // 存证 分片上传
                    let balance = await findBalance(0)
                    that.$store.commit('balance/setBalance', balance)
                    // 判断是否有 solidifySuccess 为 4 的文件（实名信息变更导致认证失败），有则不跳转
                    const hasSolidifyFail = this.timeData.some(item => item.solidifySuccess === 4)
                    if (!hasSolidifyFail) {
                        sessionStorage.setItem('serialNos',JSON.stringify(this.serialNos));
                        if(this.serialNos.length>0){
                            this.$router.replace({
                                path: '/time/ApplyResult',
                            })
                        }else{
                            location.reload();
                        }
                    }
                    
                }else if (res.deductible == 4) {//身份主账号，余额不足
                    this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
                    that.$dialog.confirm({
                        title: that.timeStampArrearageMessage(),
                        message: res.errorMessage,
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '去充值',
                        cancelButtonText: '我已充值',
                        beforeClose: (action, done) => {
                            if (action === 'confirm') {
                                that.goRecharge()
                                done();
                            } else {
                                //this.send();需要自己点按钮，防止用户不想继续了。
                                done()
                            }
                        },
                    }).then(() => {
                        console.log('去充值吧')
                    }).catch(async () => {
                        console.log('取消')
                        let balance = await findBalance(0)
                        that.$store.commit('balance/setBalance', balance)

                    })
                    return false
                }else if (res.deductible == 2) {//身份子账号，主账号余额不足
                    this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
                    that.$dialog.alert({
                        title:that.timeStampArrearageMessage(), 
                        message:res.errorMessage, 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
                    return false
                }else{//deductible=3 身份子账号，主账号分配次数达上限
                    //that.$toast('您的时间戳已用完，请联系主账号再次分配。')
                    this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
                    that.$dialog.alert({
                        title:that.timeStampArrearageMessage(), 
                        message:'您的时间戳已用完，请联系主账号再次分配。', 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
                    return false
                }
            } catch (error) {
                console.log(error)
                if(error && error.name&&error.name=='cancel'){
                    console.log('取消存证')
                }else if(error?.data?.code==300026){
                    this.$toast(error.data.message)
                }else{
                    // 如果有 solidifySuccess=4 的文件，静默返回（已在 submit 中处理）
                    const hasSolidifyFail = this.timeData.some(item => item.solidifySuccess === 4)
                    if (hasSolidifyFail) {
                        return
                    }
                    this.$toast('服务异常，请联系客服')
                }
            } finally {
                this.submitting = false;
            }
        },

        async overAttestation(){
            if(this.overNum==0){
                location.reload();
            }else{
                clearInterval(interval);
                let balance = await findBalance(0)
                this.$store.commit('balance/setBalance', balance)
                sessionStorage.setItem('serialNos', JSON.stringify(this.serialNos))
                this.$router.replace({
                    path: '/time/ApplyResult',
                })
            }
        },
        copy() {
            var clipboard = new this.Clipboard('.copybtn')
            var that = this
            clipboard.on('success', (e) => {
                // console.log('复制成功')
                // 释放内存
                that.$toast.success('复制成功')
                setTimeout(function() {
                    that.template = false
                }, 2000)
                clipboard.destroy()
            })
            clipboard.on('error', (e) => {
                // 不支持复制
                console.log('该浏览器不支持自动复制')
                that.$toast('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        openbuy(action, done){ 
            if (action === 'confirm') {
                this.goRecharge()
                //新开窗口为了返回后可以继续接着欠费之前的一些状态接着往下固化，不需要用户在重新编辑上传。
                //window.open(process.env.VUE_APP_ACCOUNTUI + `/userAccount/buy?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType'):0}`)
                done(false)
            } else if(action === 'cancel'){
                this.send();
                done();
            }else{
                if(this.opusFilePopup = true){//当前固化弹框打开，要停止固化
                    //this.opusFilePopupStop()
                    this.opusFileProgressPopupConfirm();
                }
                if(this.ossUploadPopup = true){//当前存证弹框打开，要停止存证
                    // this.ossUploadPopupStop()
                    this.ossUploadProgressPopupConfirm()
                }
                done();
            }
        },
        gobuy(path) {
            this.$router.push({
                path:'/mine/Account',
                query:{
                    url:process.env.VUE_APP_ACCOUNTUI+path
                }
            })
        },
        close(){
            this.buyDialog=false;
        },

        // 1.开启文件固化程序先脱敏扣费弹框 solidifyType 正常固化值为 1， 点击结束固化弹窗中的取消按钮，执行的接续固化 值为 2
        async fileStart({ solidifyType }) {
            return new Promise(async (resolve, reject) => {
                let obj;
                let hasUpload;//list中是否有存证的项
                try {
                    if (this.opusFileUploadSuccessNumber === this.opusFileAllUploadNumber) {
                        clearInterval(interval) // 结束保活
                        interval = null // 结束保活
                        this.opusFilePopup = false // 关闭弹窗
                        resolve()
                        return
                    }
                    // 进行保活处理
                    interval = setInterval(()=> {
                        me().then((res) => {
                            console.log('正在保活')
                        }).catch((err) => {
                            console.log(err)
                        });
                    }, 60000);
                    this.allowSolidification = true
                    if (solidifyType === 1) {
                        this.timeData.map(item => {
                            if (item.solidifySuccess !== 1) {
                                item.solidifyPercentage = 0
                                item.solidifySuccess = 0
                            }
                        })
                    }
                    this.opusFilePopup = true
                    await this.delay(0) // 用来代替 nextTick
                    this.$refs.solidifyProgressPopUp.initScroll()
                    for (let i = 0; i < this.timeData.length; i++) {
                        obj = this.timeData[i]
                        //为首都知产而加字段partnerType=1代表首都知产用户
                        obj.partnerType = this.$getlocalStorage('partnerType') || 0;
                        this.$refs.solidifyProgressPopUp.autoScroll(obj.uuid)
                        if ((solidifyType === 1 && obj.solidifySuccess !== 1) || (solidifyType === 2 && obj.solidifySuccess === 0)) { // 如果是再次固化的需要去除 固化失败的
                            this.currentIndex = i // 设置当前索引
                            let reader;
                            let fileHash = await hashFile(obj.fileItem, 'SHA256', (percentage) => {
                                if (this.allowSolidification === false) { // 固化结束
                                    reader && reader.abort()
                                    reader = null
                                    return
                                }
                                obj.solidifyPercentage = percentage
                            }, ({ reader }) => {
                                reader = reader
                                if (this.allowSolidification === false) { // 固化结束
                                    reader && reader.abort()
                                    reader = null
                                    return
                                }
                            }, 1)
                            if(fileHash===null){
                                obj.solidifySuccess = 3;
                            }else{
                                obj.fileHash = fileHash;
                                // console.log('第一步的hash', sha256)
                                if (this.allowSolidification === false) return
                                obj.opusDescribe=this.opusDescribe;
                                obj.owner=this.owner;
                                obj.applyName=this.information.applyName;
                                let res=await opusApply(obj)
                                let {code, id, message, serialNo} = res;
                                if (code === 9523100) { //固化成功
                                    // obj.md5 = CryptoJs.enc.Base64.stringify(md5)
                                    obj.serialNo = serialNo
                                    this.serialNos.push(serialNo);
                                    if (!this.isOriginal) { // 如果是脱敏的 认为是固化成功
                                        obj.id = id
                                    }
                                    obj.solidifySuccess = 1
                                    this.timeData[i]=obj
                                    this.$set(this.timeData, i, obj)
                                    let balance = await findBalance(0)
                                    this.$store.commit('balance/setBalance', balance)
                                } else {
                                    if (await this.solidifyFail(code, obj, message)) {
                                        return
                                    }
                                }
                            }
                            //如果没有存证的，那么只有固化一个弹框，判断当前是最后一个并且已完成固化，直接跳成功页。
                            if(this.opusFileProgressPopupCancelShow === true && (i == this.timeData.length-1) && obj.solidifySuccess == 1 && !hasUpload){
                                // 判断是否有 solidifySuccess 为 4 的文件，有则刷新申请人信息而非跳转
                                const hasSolidifyFail = this.timeData.some(item => item.solidifySuccess === 4)
                                if (hasSolidifyFail) {
                                    this.getUserInfo()
                                } else {
                                    sessionStorage.setItem('serialNos',JSON.stringify(this.serialNos));
                                    this.$router.replace({
                                        path: '/time/ApplyResult',
                                    })
                                }
                                return
                            }
                            // 如果弹出了取消固化的弹窗，就自动停止，不进入下一个循环
                            if (this.opusFileProgressPopupCancelShow === true) return
                        }
                    }
                    await this.delay(1000) // 如果此时结束了固化
                    console.log('固化结束')
                    clearInterval(interval) // 结束保活
                    interval = null // 结束保活
                    for (let i = 0; i < this.timeData.length; i++) {
                        if (this.timeData[i].solidifySuccess === 3) {
                            this.timeData.splice(i, 1)
                            i--
                        }
                    }
                    if (this.opusFileUploadSuccessNumber === this.opusFileAllUploadNumber) {
                        this.opusFilePopup = false // 关闭弹窗
                        console.log('****************')
                        // if (this.allowSolidification === true) { // 允许固化的时候固化
                        //     callback && callback()
                        // }
                        resolve()
                    } else {
                        console.log('------solidify-----has---fail---')
                        reject()
                    }
                } catch (error) {
                    console.log(error)
                    console.log('------solidify-----error---')
                    if (obj) {
                        obj.solidifySuccess = 2
                    }
                    reject(error)
                }
            })
        },
        async solidifyFail (code, obj, message) {
            obj.solidifySuccess = 2;
            if (code === 9523101) { // 固化失败了
                //obj.solidifySuccess = 2
                return false
            }else if(code === 9523103){//实名信息变化
                obj.solidifySuccess = 4
                return false
            } else if (code === 10001) { //
                this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
                if(this.userInfo.userType === 'ADMIN_ACCOUNT') { // 主账号
                    this.buyDialog=true;
                    this.buyDialogCnt.title=this.timeStampArrearageMessage();
                    this.buyDialogCnt.message=message;
                    this.opusFilePopup = false
                    this.opusFileProgressPopupCancelShow = false
                    return true
                } else {
                    this.$dialog.alert({
                        title:this.timeStampArrearageMessage(), 
                        message:message, 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
                    this.opusFilePopup = false
                    this.opusFileProgressPopupCancelShow = false
                    return true
                }
            } else {
                this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
                // 10013 子账号超出最大限额
                this.$dialog.alert({
                    title:this.timeStampArrearageMessage(),
                    message:message, 
                    confirmButtonColor:'#008AFF',
                    confirmButtonText: '我知道了',
                })
                this.opusFilePopup = false
                this.opusFileProgressPopupCancelShow = false
                return true
            }
        },
        //固化过程中，点击取消显示的弹窗
        opusFilePopupStop () {
            this.opusFileProgressPopupCancelShow = true
        },
        //固化过程中，点击取消
        async opusFileProgressPopupCancel () {
            let currentObj = this.timeData[this.currentIndex]
            // 如果结束固化的过程中存在 hash算完并且 opusApply 还没处理完的情况下
            if (currentObj.solidifyPercentage === 100 && currentObj.solidifySuccess === 0) {
                this.$toast('当前文件即将认证成功，请稍后处理');
            } else {
                this.opusFileProgressPopupCancelShow = false // 关闭弹窗 （必须先关闭）
                // 如果点击取消的时候，流程没有进入固化 代码继续往下走，如果已经进入了固化接口，那么执行下面的函数，重新执行固化函数，继续固化
                if (currentObj.solidifySuccess !== 0) {
                    await this.fileStart({ solidifyType: 2 })
                    await this.existingEvidence({ existingEvidenceType: 2 })
                }
            }
        },
        //固化过程中，点击确定结束固化
        opusFileProgressPopupConfirm () {
            let currentObj = this.timeData[this.currentIndex]
            // 如果结束固化的过程中存在 hash算完并且 opusApply 还没处理完的情况下
            if (currentObj.solidifyPercentage === 100 && currentObj.solidifySuccess === 0) {
                this.$toast('当前文件即将认证成功，请稍后处理');
            } else {
                clearInterval(interval) // 结束保活
                interval = null // 结束保活
                this.$store.commit('axiosCancel/clearAxiosPromiseCancelArr')
                this.allowSolidification = false
                this.opusFilePopup = false
                this.opusFileProgressPopupCancelShow = false
                // 刷新申请人信息（可能因实名信息变更导致认证失败）
                this.getUserInfo()
            }
        },
        // 2.全部脱敏扣费后再继续存证上传扣费
        async existingEvidence ({ existingEvidenceType }) {
            return new Promise(async (resolve, reject) => {
                //console.log(this.ossSliceUploadSuccessNumber+'----'+this.ossSliceAllUploadNumber)
                if (this.ossSliceUploadSuccessNumber === this.ossSliceAllUploadNumber) {
                    clearInterval(interval) // 结束保活
                    interval = null // 结束保活
                    this.ossUploadPopup = false // 有改动
                    resolve()
                    return
                }
                let obj;
                // 需要判断钱是否够
                try {
                    // 进行保活处理
                    interval = setInterval(()=> {
                        me().then((res) => {
                            console.log('正在保活')
                        }).catch((err) => {
                            console.log(err)
                        });
                    }, 60000);
                    this.allowExistingEvidence = true
                    if (existingEvidenceType === 1) {
                        this.timeData.map(item => {
                            if (item.ossSliceUploadSuccess !== 1 && this.isOriginal) {
                                item.ossSliceUploadPercentage = 0
                                item.ossSliceUploadSuccess = 0
                            }
                        })
                    }
                    this.ossUploadPopup = true
                    await this.delay(0) // 用来代替 nextTick
                    this.$refs.ossSliceUploadProgressPopUp.initScroll()
                    for (let i = 0; i < this.timeData.length; i++) {
                        obj = this.timeData[i]
                        if (this.isOriginal && ((existingEvidenceType === 1 && !obj.id) || (existingEvidenceType === 2 && obj.ossSliceUploadSuccess === 0) )) {
                            this.currentIndex = i
                            this.$refs.ossSliceUploadProgressPopUp.autoScroll(obj.uuid)
                            let { fileHash, serialNo, fileItem, applyFileSize,years } = obj
                            if (this.allowExistingEvidence === false) return
                            let { accessKey, secretKey, secretToken, bucket, key , storeId} = await generateStsUploadSignMessage(encrypt({
                                serialNo, 
                                applyFileSize,
                                partnerType:this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType'):0,
                                years,
                            }), 'nqio8Mem5oDNNBxOStIAlIsxrtWAx/c8')
                            obj.storeId = storeId
                            if (this.allowExistingEvidence === false) return
                            try {
                                await ossMultipartUpload({
                                    fileHash,
                                    accessKey,
                                    secretKey,
                                    secretToken,
                                    bucket,
                                    key,
                                    file:fileItem,
                                }, ({ percentage }) => {
                                    obj.ossSliceUploadPercentage = percentage
                                })
                            } catch (error) {
                                console.log(error)
                                //文件完整性校验未通过 (MD5 不匹配)'
                                if(error.code === 'InvalidDigest'){
                                    this.$toast('文件完整性校验未通过')
                                    obj.ossSliceUploadSuccess = 2 // 上传失败
                                    try {
                                        // 删除oss上校验失败的文件
                                        await cancelStsUpload({
                                            serialNo: obj.serialNo,
                                            storeId: obj.storeId,
                                        })
                                    } catch (error) {
                                        console.log(error)
                                    }
                                }else{
                                    //this.$toast('当前文件上传失败')
                                    obj.ossSliceUploadSuccess = 2 // 上传失败                                 
                                }
                                this.timeData[i]=obj;
                                this.$set(this.timeData, i, obj)
                                if(this.ossUploadProgressPopupCancelShow === true && (i == this.timeData.length-1) && obj.ossSliceUploadSuccess == 1){//再点取消的时候，最后一个已经存证完成，那就直接跳转到成功页
                                    // 判断是否有 solidifySuccess 为 4 的文件，有则不跳转
                                    const hasSolidifyFail = this.timeData.some(item => item.solidifySuccess === 4)
                                    if (!hasSolidifyFail) {
                                        this.close()
                                    }
                                    return
                                }
                                continue;
                            }
                            if (this.allowExistingEvidence === false) return
                            let { id } = await this.ossSliceUploadGetStatus({serialNo,storeId})
                            if (id) { 
                                obj.ossSliceUploadSuccess = 1 // 上传成功
                                obj.id = id
                            } else {
                                obj.ossSliceUploadSuccess = 2 // 上传失败
                            }
                            this.timeData[i]=obj;
                            this.$set(this.timeData, i, obj)
                            if(this.ossUploadProgressPopupCancelShow === true && (i == this.timeData.length-1) && obj.ossSliceUploadSuccess == 1){//再点取消的时候，最后一个已经存证完成，那就直接跳转到成功页
                                // 判断是否有 solidifySuccess 为 4 的文件，有则不跳转
                                const hasSolidifyFail = this.timeData.some(item => item.solidifySuccess === 4)
                                if (!hasSolidifyFail) {
                                    sessionStorage.setItem('serialNos',JSON.stringify(this.serialNos));
                                    this.$router.replace({
                                        path: '/time/ApplyResult',
                                    })
                                }
                                return
                            }
                            if (this.ossUploadProgressPopupCancelShow === true) return
                        }
                    }
                    await this.delay(1000) // 1秒后结束固化
                    clearInterval(interval) // 结束保活
                    interval = null // 结束保活
                    if (this.ossSliceUploadSuccessNumber === this.ossSliceAllUploadNumber) {
                        this.ossUploadPopup = false
                        resolve()
                    } else {
                        reject()
                    }
                } catch (error) {
                    if (error && error.config) {
                        let { code, message } = error.data
                        if (ExcludeRequest400.indexOf(error.config.url) > -1) {
                            // 存证失败的情况
                            this.existingEvidenceFail(code, obj, message)
                            return
                        }
                    }
                    reject(error)
                }
            })
        },
        // 查询最新的存证状态
        ossSliceUploadGetStatus ({serialNo,storeId}, onOff) {
            return new Promise((resolve, reject) => {
                let time = null;
                clearTimeout(time)
                const getStatus = ({ serialNo, storeId }) => {
                    if (this.allowExistingEvidence === false && !onOff) {
                        resolve({})
                        return
                    }
                    completeStatus({serialNo,storeId}).then(async res => {
                        if (this.allowExistingEvidence === true || onOff) {
                            if (res.sourceFileUploadType === 0) { // 状态没有更新，继续轮询
                                time = setTimeout(() => {
                                    getStatus({ serialNo, storeId })
                                }, 1000)
                            } else {
                                resolve(res)
                                clearTimeout(time)
                                time = null
                                let balance = await findBalance(0)
                                this.$store.commit('balance/setBalance', balance)
                            }
                        } else {
                            resolve({})
                            clearTimeout(time)
                            time = null
                        }
                    }).catch((error) => {
                        resolve({})
                        clearTimeout(time)
                        time = null
                    })
                }
                getStatus({ serialNo, storeId })
            })
        },
        timeStampArrearageMessage () {
            return '本次申请需要消耗时间戳 ' + this.TotalTimestampsCount + ' 个'
        },
        // 存证失败
        async existingEvidenceFail (code,obj, message) {
            // code 2 您的主账号余额不足，请联系主账号充值
            // code 3 您的使用个数已达上限，请联系主账号分配
            // code 4 您的余额不足，请充值后在使用
            message = message || '系统错误'
            this.ossUploadPopup = false // 关闭存证进度弹窗
            this.ossUploadProgressPopupCancelShow = false // 关闭结束存证的弹窗（会出现，几率很小）
            obj.ossSliceUploadSuccess = 2
            clearInterval(interval) // 清空保活接口
            interval = null
            this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
            switch (code) {
                case 2:
                    this.$dialog.alert({
                        title:this.timeStampArrearageMessage(),
                        message:message, 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
                    break
                case 3:
                    this.$dialog.alert({
                        title:this.timeStampArrearageMessage(),
                        message:message, 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
                    break
                case 4:
                    this.buyDialog=true;
                    this.buyDialogCnt.title=this.timeStampArrearageMessage()
                    this.buyDialogCnt.message=message;
                    break
                default:
                    this.$dialog.alert({
                        title:this.timeStampArrearageMessage(),
                        message:message, 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
            }
        },
        //存证过程中，点击取消显示的弹窗
        ossUploadPopupStop () {
            this.ossUploadProgressPopupCancelShow = true
        },
        //存证过程中，点击结束存证
        async ossUploadProgressPopupConfirm () {
            try {
                this.ossUploadProgressPopupCancelDisabled = true // 禁止重复点击
                let currentObj = this.timeData[this.currentIndex]
                if (this.isOriginal && currentObj.ossSliceUploadPercentage === 100 && currentObj.ossSliceUploadSuccess === 0) {
                    this.$toast('当前文件即将上传成功，请稍后处理');
                } else {
                    clearInterval(interval) // 清空保活接口
                    interval = null
                    // 这里可能还需要清除一个定时器
                    this.allowExistingEvidence = false // 存证不允许
                    // 如果上传成功的都不允许删除
                    if (currentObj.ossSliceUploadPercentage < 100) {
                            await ossAbortMultipartUpload() // 取消oss请求
                            // 需要调用终止分片的接口 （已经上传到服务器的就不能被取消了）
                            await cancelStsUpload({
                                serialNo: currentObj.serialNo,
                                storeId: currentObj.storeId,
                            })
                        }
                    this.$store.commit('axiosCancel/clearAxiosPromiseCancelArr')
                    this.ossUploadPopup = false
                    this.ossUploadProgressPopupCancelShow = false
                }
                this.ossUploadProgressPopupCancelDisabled = false // 禁止重复点击
            } catch (error) {
                if (error && error.status === 400 && error.data && error.data.code == -1 && error.config && error.config.url === '/opus/cancelStsUpload') {
                    this.allowExistingEvidence = true
                    let { id } = await this.ossSliceUploadGetStatus({serialNo,storeId}, true)
                    if (id) {
                        currentObj.ossSliceUploadSuccess = 1 // 上传成功
                        currentObj.id = id
                        currentObj.ossSliceUploadPercentage = 100 // 成功
                    } 
                    await this.existingEvidence({ existingEvidenceType: 2 })
                } else {
                    //await ossAbortMultipartUpload() // 取消oss请求
                    clearInterval(interval) // 清空保活接口
                    interval = null
                    this.allowExistingEvidence = false // 存证不允许
                    this.ossUploadProgressPopupCancelDisabled = false // 禁止重复点击
                    this.$store.commit('axiosCancel/clearAxiosPromiseCancelArr')
                    this.ossUploadPopup = false
                    this.ossUploadProgressPopupCancelShow = false
                }
            }
        },
        async ossUploadProgressPopupCancel () {
            let currentObj = this.timeData[this.currentIndex]
            if (this.isOriginal && currentObj.ossSliceUploadPercentage === 100 && currentObj.ossSliceUploadSuccess === 0) {
                this.$toast('当前文件即将上传成功，请稍后处理');
            }else{
                this.ossUploadProgressPopupCancelShow = false // 关闭弹窗 （必须先关闭）
                // 如果点击取消的时候，流程没有进入存证 代码继续往下走，如果已经进入了存证接口，那么执行下面的函数，重新执行固化、、存证函数，继续存证
                if (this.isOriginal && currentObj.ossSliceUploadSuccess !== 0) {
                    await this.existingEvidence({ existingEvidenceType: 2 })
                }
            }
        },
        handleInputNum:debounce(function(){
            this.storageYear = this.storageYear.replace(/\D|^0/g, '');
            this.storageYear = this.storageYear  > 1000 ? 1000 : this.storageYear;
            if(this.storageYear){
                this.changeTimeDataYear();
            }
        }, 500),
        handleInputNumBlur(e){
            let value = e.target.value;
            if(!value){
                e.target.value=3;
                this.storageYear=3;
            }
        },
        changeStorageYearNum(){
            this.storageYear && this.changeTimeDataYear();
        },
        beforeClose(action, done){
            if (action === 'confirm') {
                if(!this.checked){
                    this.$toast('请先阅读并勾选协议内容')
                    done(false)
                }else{
                    done()
                    this.submit();
                }
            }else{
                done()
            }
        },
    },
};
</script>
<style src="../../assets/css/applyTime.less" scoped lang="less"></style>
